<template>
  <div class="letest-section pb-60 pt-60">
    <div class="container-fluid">
      <div class="section-wrapper">
        <h2 class="left-title">{{ $t("Leaderboard") }}</h2>
      </div>
      <Leaderboard />
    </div>
  </div>
</template>

<script>
import Leaderboard from "@/components/partials/Leaderboard.vue";

export default {
  name: "LeaderboardView",
  components: {
    Leaderboard,
  },
};
</script>
